import React, { Children, useEffect, useState, createRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Chip,
  makeStyles,
  Checkbox,
} from "@material-ui/core";
import moment from "moment-timezone";
import { DragDropContext } from "react-beautiful-dnd";
import { getLanguage, labels } from "../../shared/translations";
import { theme } from "../../../components/theme";
import SpTextInput from "../../../components/atoms/SpTextInput";
import SpButton from "../../../components/atoms/SpButton";
import SpLoader from "../../../components/atoms/SpLoader";
import {
  changeSlot,
  getOrganizationSchedule,
  updateOrganizationSchedule,
} from "../../../models/actions/Organization";
import SpText from "../../../components/atoms/SpText";
import { useForm } from "react-hook-form";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import SpAutocomplete from "../../../components/atoms/SpAutocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import { Calendar, momentLocalizer } from "react-big-calendar";

import {
  ColoredEventCellHelperDay,
  ColoredEventCellHelperMonth,
  ColoredEventCellHelperWeek,
  SpCalendarItemOrganization,
} from "./SpCalendarItemOrganization";
import { momentDefinition } from "../../../utils/common";
import { expandSlotsByIdGrouped } from "./OrganizationHelper";

const useStyles = makeStyles((themeStyle) => ({
  largeAvatar: {
    margin: "8px",
    width: themeStyle.spacing(5),
    height: themeStyle.spacing(5),
  },
}));

const DragAndDropPage = ({ props, professionals, selectedProfessional }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [time, setTime] = useState({ start: "", end: "" });
  const [slotTime, setSlotTime] = useState(30);
  const [daysAvailable, setDaysAvailable] = useState(7);
  const [loading, setLoading] = useState(false);
  const [changeDay, setChangeDay] = useState();
  const [changeStartTime, setChangeStartTime] = useState();
  const [changeEndTime, setChangeEndTime] = useState();

  const [oldProf, setOldProf] = useState();
  const [newProf, setNewProf] = useState();

  const [draggedEvent, setDraggedEvent] = useState(null);
  const [eventsList, setEventsList] = useState([]);
  const [monthSelected, setMonthSelected] = useState(moment());
  const [viewSelected, setViewSelected] = useState("month");
  const [displayDragItemInCell, setDisplayDragItemInCell] = useState(true);

  const DragAndDropCalendar = withDragAndDrop(Calendar);
  moment.locale(getLanguage(), momentDefinition);
  const localizer = momentLocalizer(moment);

  useEffect(() => {
    fetchData();
  }, [professionals]);

  const handleEventDrop = async ({
    event,
    start,
    end,
    isAllDay: droppedOnAllDaySlot,
  }) => {
    let allDay = event.allDay;
    if (!event.allDay && droppedOnAllDaySlot) {
      allDay = true;
    } else if (event.allDay && !droppedOnAllDaySlot) {
      allDay = false;
    }
    const nextEvents = eventsList.map((existingEvent) => {
      return existingEvent?.id === event?.id
        ? { ...existingEvent, start, end, allDay }
        : existingEvent;
    });
    event.start_date = moment(start);
    event.end_date = moment(end);
    // await updateActivity(event);
    setEventsList(nextEvents);
  };

  const dragFromOutsideItem = () => {
    return draggedEvent;
  };

  const fetchData = async () => {
    let ret = await getOrganizationSchedule({});
    Object.keys(ret).forEach((key) => {
      setDaysAvailable(ret[key].days_available);
      setSlotTime(ret[key].slot_time);
    });
    if (selectedProfessional) {
      const idStr = String(selectedProfessional);
      if (ret[idStr]) {
        setEventsList(
          expandSlotsByIdGrouped(
            {
              [idStr]: ret[idStr],
            },
            professionals
          )
        );
      }
    } else {
      setEventsList(expandSlotsByIdGrouped(ret, professionals));
    }
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;

    if (
      source.droppableId === "people" &&
      labels.week.map(({ key }) => key).includes(destination.droppableId)
    ) {
      setDialogOpen(true); // Apri il dialogo
    }
  };

  const handleConfirm = () => {
    // Aggiungi la persona alla colonna selezionata con gli orari
    const newDragged = {
      ...draggedEvent,
      media: draggedEvent.profileImage,
      start: new Date(
        `${moment(draggedEvent.start).format("YYYY-MM-DD")}T${
          time.start
        }:00.000`
      ), // Converte in oggetto Date
      end: new Date(
        `${moment(draggedEvent.end).format("YYYY-MM-DD")}T${time.end}:00.000`
      ),
    };

    setEventsList([...eventsList, newDragged]);
    setDraggedEvent(null);
    setDialogOpen(false);
    setTime({ start: "", end: "" });
  };

  const handleCancel = () => {
    setDialogOpen(false);
    setTime({ start: "", end: "" });
  };

  const MyCustomHeader = ({ label }) => (
    <div style={{ width: "100%", backgroundColor: "#333333", color: "#FFF" }}>
      <div style={{ color: "#FFF" }}>{label}</div>
    </div>
  );

  const handleDragStart = (event) => {
    setDraggedEvent(event);
    setDisplayDragItemInCell(false);
  };

  const onDropFromOutside = async ({ start, end, allDay }) => {
    setDraggedEvent({
      ...draggedEvent,
      start: new Date(start),
      end: new Date(start),
    });
    setDialogOpen(true);
  };

  const handleEventDetailSelected = async (event) => {
    if (!selectedProfessional)
      setEventsList(
        eventsList.filter((e) => e.id !== event.id || event.start != e.start)
      );
  };

  const handleNewEventSelected = (event) => {
    // console.log("handleNewEventSelected", event);
  };

  const goToBackGeneral = (toolbar) => {
    try {
      let newDate = toolbar.date;

      switch (toolbar.view) {
        case "month":
          newDate = new Date(
            newDate.getFullYear(),
            newDate.getMonth() - 1,
            newDate.getDate()
          );
          toolbar.onNavigate("prev", newDate);
          setMonthSelected(newDate);
          break;
        case "week":
          newDate = new Date(
            newDate.getFullYear(),
            newDate.getMonth(),
            newDate.getDate() - 7
          );
          toolbar.onNavigate("prev", newDate);
          setMonthSelected(newDate);
          break;
        case "day":
          newDate = new Date(
            newDate.getFullYear(),
            newDate.getMonth(),
            newDate.getDate() - 1
          );
          toolbar.onNavigate("prev", newDate);
          setMonthSelected(newDate);
          break;

        default:
          break;
      }
    } catch (error) {
      rollbar.error("PatientsPlan - goToBackGeneral", error);
    }
  };
  const goToNextGeneral = (toolbar) => {
    try {
      let newDate = toolbar.date;

      switch (toolbar.view) {
        case "month":
          newDate = new Date(
            newDate.getFullYear(),
            newDate.getMonth() + 1,
            newDate.getDate()
          );
          toolbar.onNavigate("prev", newDate);
          setMonthSelected(newDate);
          break;
        case "week":
          newDate = new Date(
            newDate.getFullYear(),
            newDate.getMonth(),
            newDate.getDate() + 7
          );
          toolbar.onNavigate("prev", newDate);
          setMonthSelected(newDate);
          break;
        case "day":
          newDate = new Date(
            newDate.getFullYear(),
            newDate.getMonth(),
            newDate.getDate() + 1
          );
          toolbar.onNavigate("prev", newDate);
          setMonthSelected(newDate);
          break;

        default:
          break;
      }
    } catch (error) {
      rollbar.error("PatientsPlan - goToNextGeneral", error);
    }
  };

  const CustomToolbar = (toolbar) => {
    const goToBack = () => {
      goToBackGeneral(toolbar);
    };

    const goToNext = () => {
      goToNextGeneral(toolbar);
    };

    const goToCurrent = () => {
      const now = new Date();
      toolbar.onNavigate("current", now);
      setMonthSelected(now);
    };

    const label = () => {
      const date = moment(toolbar.date);
      return (
        <SpText variant="monthYearCalendar">
          {toolbar.view === "day" && (
            <>
              <b>{date.format("DD")}</b>{" "}
            </>
          )}
          <b>{date.format("MMMM")}</b>
          <span> {date.format("YYYY")}</span>
        </SpText>
      );
    };

    return (
      <div
        container
        className="rbc-toolbar"
        spacing={1}
        style={{ marginBottom: "1%", justifyContent: "space-evenly" }}
      >
        <label style={{ justifyContent: "center" }} className={"label-date"}>
          {label()}
        </label>

        <div className="back-next-buttons">
          <button
            style={{ color: "#FFF" }}
            className="btn-back"
            onClick={() => {
              setViewSelected("month");
            }}
          >
            {labels.groups.plan.month}
          </button>
          <button
            style={{ color: "#FFF" }}
            className="btn-current"
            onClick={() => {
              setViewSelected("week");
            }}
          >
            {labels.groups.plan.week}
          </button>
          <button
            style={{ color: "#FFF" }}
            className="btn-next"
            onClick={() => {
              setViewSelected("day");
            }}
          >
            {labels.groups.plan.day}
          </button>
        </div>

        <div className="back-next-buttons">
          <button
            style={{ color: "#FFF", borderColor: "#FFF" }}
            className="btn-back"
            onClick={goToBack}
          >
            {labels.groups.plan.prev}
          </button>
          <button
            style={{ color: "#FFF", borderColor: "#FFF" }}
            className="btn-current"
            onClick={goToCurrent}
          >
            {labels.groups.plan.today}
          </button>
          <button
            style={{ color: "#FFF", borderColor: "#FFF" }}
            className="btn-next"
            onClick={goToNext}
          >
            {labels.groups.plan.next}
          </button>
        </div>
      </div>
    );
  };

  const dateHeader = ({ date, label }) => {
    if (moment(monthSelected).format("MM") === moment(date).format("MM")) {
      return <h3 style={{ color: "lightGray" }}>{label}</h3>;
    } else {
      return <h3 style={{ color: "gray" }}>{label}</h3>;
    }
  };

  const AgendaEventWrapper = (props) => {
    return React.cloneElement(Children.only(props.children), {
      style: {
        ...props.children.props.style,
        width: "100%",
        backgroundColor: props.event.color,
        padding: `0px`,
        color: "white !important",
      },
    });
  };

  function transformSlotsById(dataArray) {
    const result = {};
    dataArray.forEach((obj) => {
      const startDate = new Date(obj.start);
      const endDate = new Date(obj.end);

      // 'YYYY-MM-DD' in UTC
      const date = startDate.toISOString().split("T")[0];

      // Costruisci gli slot (in UTC) come "HH:mm - HH:mm"
      const slots = [];
      let current = new Date(startDate);
      while (current < endDate) {
        const hours = current.getUTCHours().toString().padStart(2, "0");
        const minutes = current.getUTCMinutes().toString().padStart(2, "0");
        const startSlot = `${hours}:${minutes}`;

        // Calcola fine slot
        const next = new Date(current);
        next.setUTCMinutes(next.getUTCMinutes() + slotTime);
        const endHours = next.getUTCHours().toString().padStart(2, "0");
        const endMinutes = next.getUTCMinutes().toString().padStart(2, "0");
        const endSlot = `${endHours}:${endMinutes}`;

        slots.push(`${startSlot} - ${endSlot}`);
        current = next;
      }

      // Aggiunge al risultato, raggruppando per ID
      if (!result[obj.id]) {
        result[obj.id] = {
          name: obj.name,
          surname: obj.surname,
          id_file: obj.id_file,
          dates: {},
        };
      }

      // Aggiunge lo slot sotto la data corrispondente
      if (!result[obj.id].dates[date]) {
        result[obj.id].dates[date] = [];
      }

      result[obj.id].dates[date].push(...slots);
    });
    return result;
  }

  const saveSchedule = async () => {
    setLoading(true);
    if (!(parseInt(slotTime) > 0)) {
      props.snackbarShowErrorMessage(labels.requestsList.slotTimeError);
    } else if (!(parseInt(daysAvailable) > 0)) {
      props.snackbarShowErrorMessage(labels.requestsList.daysAvailableError);
    } else {
      const data = transformSlotsById(eventsList);
      const ret = await updateOrganizationSchedule({
        data: data,
        slotTime: slotTime,
        daysAvailable: daysAvailable,
      });
      await fetchData();
      if (ret?.message) {
        props.snackbarShowMessage(ret.message);
      }
      if (ret?.error) {
        props.snackbarShowErrorMessage(ret.error);
      }
    }
    setLoading(false);
  };

  const SelectProfessional = ({ prof, seleProf, label }) => {
    return (
      <SpAutocomplete
        style={{ width: "100%", height: "100%", maxHeight: "100%" }}
        formControlWidth={"100%"}
        label={label}
        options={professionals}
        getOptionLabel={(option) =>
          `${
            option?.name ?? labels.agency.licenses.buyLicenseDialog.professional
          } ${option?.surname ?? ""}`
        }
        getOptionSelected={(opt, value) => {
          return opt.id === value.id;
        }}
        value={prof ?? []}
        onChange={(_, newValue) => seleProf(newValue)}
        renderOption={(props, option) => (
          <li
            key={`option_${props.id}`}
            style={{
              color: option.selected
                ? theme.colors.primary.white
                : theme.colors.primary.black,
            }}
          >
            <Checkbox
              name={props.id}
              icon={<CheckBoxOutlineBlankIcon small />}
              checkedIcon={<CheckBoxIcon small />}
              style={{
                marginRight: 5,
                color: option.selected
                  ? theme.colors.primary.white
                  : theme.colors.primary.black,
              }}
              checked={option.selected}
            />
            {`${props?.name} ${props?.surname}`}
          </li>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const _val = professionals.find(
              (x) => x.id === (option.id ?? option)
            );
            return (
              <Chip
                key={_val?.id}
                style={{
                  backgroundColor: theme.colors.primary.lightBlue,
                  color: theme.colors.primary.white,
                }}
                label={`${_val?.name} ${_val?.surname}`}
                size="medium"
                {...getTagProps({ index })}
              />
            );
          })
        }
      />
    );
  };

  return (
    <Grid
      style={{ paddingLeft: "1%" }}
      direction="column"
      container
      spacing={2}
    >
      {loading && <SpLoader />}
      {React.Children.map(props.children, (child) =>
        React.cloneElement(child, {
          setLoading: setLoading,
          componentName: props.componentName,
        })
      )}

      <DragDropContext onDragEnd={onDragEnd}>
        {!selectedProfessional && (
          <Grid
            container
            direction="row"
            spacing={1}
            alignContent="start"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={2}>
              <SpTextInput
                style={{ width: "100%" }}
                name="slot_time"
                label={labels.requestsList.slot_time}
                type="number"
                maxValue="100"
                variant="text"
                defaultValue={30}
                value={slotTime}
                onChange={(e) => setSlotTime(e.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              <SpTextInput
                style={{ width: "100%" }}
                name="days_available"
                label={labels.requestsList.availableDays}
                type="number"
                maxValue="100"
                variant="text"
                defaultValue={7}
                value={daysAvailable}
                onChange={(e) => setDaysAvailable(e.target.value)}
              />
            </Grid>
          </Grid>
        )}

        <Grid container direction="row" spacing={1}>
          {!selectedProfessional && (
            <Grid
              item
              xs={2}
              style={{
                position: "sticky",
                top: 0,
                height: "100%",
                marginTop: "0px",
              }}
            >
              <SpCalendarItemOrganization
                activitiesAvailable={professionals}
                handleDragStart={handleDragStart}
              />
            </Grid>
          )}

          <Grid
            item
            xs={!selectedProfessional ? 10 : 12}
            style={{ minHeight: "350px" }}
          >
            <div>
              {
                <DragAndDropCalendar
                  selectable
                  step={30}
                  min={new Date(0, 0, 0, 5, 0, 0)}
                  max={new Date(0, 0, 0, 23, 0, 0)}
                  events={eventsList}
                  scrollToTime={new Date(monthSelected)}
                  date={new Date(monthSelected)}
                  view={viewSelected}
                  onEventDrop={handleEventDrop}
                  popup={true}
                  dragFromOutsideItem={
                    displayDragItemInCell ? dragFromOutsideItem : null
                  }
                  onDropFromOutside={onDropFromOutside}
                  handleDragStart={handleDragStart}
                  onSelectEvent={handleEventDetailSelected}
                  onSelectSlot={handleNewEventSelected}
                  messages={{
                    showMore: (total) => (
                      <a
                        style={{ cursor: "pointer" }}
                        onMouseOver={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        {`+${total} ${labels.groups.plan.viewMore}`}
                      </a>
                    ),
                  }}
                  components={{
                    timeGutterHeader: (props) => (
                      <div style={{ color: "red" }}>{props.children}</div>
                    ),
                    month: {
                      toolbar: (toolbar) => CustomToolbar(toolbar),

                      header: MyCustomHeader,
                      dateHeader: dateHeader,

                      event: ({ event }) => {
                        return (
                          <ColoredEventCellHelperMonth
                            event={event}
                            selectedProfessional={selectedProfessional}
                          />
                        );
                      },
                      eventWrapper: AgendaEventWrapper,
                    },
                    week: {
                      toolbar: (toolbar) => CustomToolbar(toolbar),

                      header: MyCustomHeader,
                      dateHeader: dateHeader,

                      event: ColoredEventCellHelperWeek,
                      eventWrapper: AgendaEventWrapper,
                    },
                    day: {
                      toolbar: (toolbar) => CustomToolbar(toolbar),

                      header: MyCustomHeader,
                      dateHeader: dateHeader,

                      event: ColoredEventCellHelperDay,
                      eventWrapper: AgendaEventWrapper,
                    },
                  }}
                  localizer={localizer}
                />
              }
            </div>
          </Grid>
        </Grid>

        {/* Dialog for Time Selection */}
        <Dialog open={dialogOpen} onClose={handleCancel}>
          <DialogTitle>Set Time for {draggedEvent?.name}</DialogTitle>
          <DialogContent>
            <TextField
              label="Start Time"
              type="time"
              fullWidth
              value={time.start}
              onChange={(e) => setTime({ ...time, start: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="End Time"
              type="time"
              fullWidth
              value={time.end}
              onChange={(e) => setTime({ ...time, end: e.target.value })}
              InputLabelProps={{ shrink: true }}
              style={{ marginTop: 16 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="primary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </DragDropContext>
      {!selectedProfessional && (
        <div style={{ padding: 20 }}>
          <SpButton
            type="submit"
            buttonType={"accept"}
            variant="none"
            onClick={async () => {
              await saveSchedule();
            }}
            text={labels.groups.groupDetail.actions.save}
          />
        </div>
      )}
      {!selectedProfessional && (
        <>
          <SpText variant="h1">{labels.requestsList.changeProfessional}</SpText>
          <Grid container direction="row">
            <Grid item xs={3}>
              <SelectProfessional
                prof={oldProf}
                seleProf={setOldProf}
                label={labels.requestsList.oldProfessional}
              />
            </Grid>
            <Grid item xs={3}>
              <SelectProfessional
                prof={newProf}
                seleProf={setNewProf}
                label={labels.requestsList.newProfessional}
              />
            </Grid>

            <Grid item xs={1}>
              <SpTextInput
                name="change_day"
                label={labels.requestsList.dateChange}
                type="date"
                maxValue="100"
                variant="text"
                style={{ width: "100%", paddingTop: "0.7em" }}
                onChange={(e) => setChangeDay(e.target.value)}
              />
            </Grid>

            <Grid item xs={1}>
              <SpTextInput
                name="start_time"
                label={labels.patient.viewPlan.addActivity.inputForm.start_time}
                type="time"
                maxValue="100"
                variant="text"
                style={{ width: "100%", paddingTop: "0.7em" }}
                onChange={(e) => setChangeStartTime(e.target.value)}
              />
            </Grid>

            <Grid item xs={1}>
              <SpTextInput
                name="end_time"
                label={labels.patient.viewPlan.addActivity.inputForm.end_time}
                type="time"
                maxValue="100"
                variant="text"
                style={{ width: "100%", paddingTop: "0.7em" }}
                onChange={(e) => setChangeEndTime(e.target.value)}
              />
            </Grid>
            <Grid item xs={3} style={{ width: "100%", paddingTop: "1.9em" }}>
              <SpButton
                type="submit"
                buttonType={"accept"}
                variant="none"
                onClick={async () => {
                  const ret = await changeSlot({
                    date: changeDay,
                    start_time: moment(changeStartTime, "HH:mm:ss")
                      .utc()
                      .format("HH:mm:ss"),
                    end_time: moment(changeEndTime, "HH:mm:ss")
                      .utc()
                      .format("HH:mm:ss"),
                    old_professional_id: oldProf.id,
                    new_professional_id: newProf.id,
                  });

                  if (ret.message) {
                    props.snackbarShowMessage(ret.message);
                    await fetchData();
                  } else {
                    props.snackbarShowErrorMessage(ret.error);
                  }
                }}
                text={labels.groups.groupDetail.actions.save}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default DragAndDropPage;
